import React, { useState, useEffect } from 'react';
import { OrgChartComponent } from '../../Components/OrgChart';

import Navbar from '../../Components/Navbar';

import { Link } from "react-router-dom";


const ProgressionPage = (props) => {

    const [data, setData] = useState(null);

    let addNodeChildFunc = null;


    function onNodeClick(d) {

        let focusTitle = document.getElementById("rankTitle")
        let focusImage = document.getElementById("rankImage")
        let focusDescription = document.getElementById("rankDescription")
        let focusDescription2 = document.getElementById("rankDescription2")
        let focusSubTitle = document.getElementById("rankSubTitle")
        let focusSolde = document.getElementById("rankSolde")
        let focusButin = document.getElementById("rankButin")
        let focusPP = document.getElementById("rankPP")
        let focusPrérequis = document.getElementById("rankPrerequis")
        let focusPrérequis2 = document.getElementById("rankPrerequis2")

        // if (d != "Professionnalisation" && d!= "Spécialisations" && d!= "Marines" && d!= "Flotte" && d!= "Logistique") {
        //     document.querySelector(".fuckingModal").style.display = "flex"
        // }
        if (d === "Postulant" || d === "Recrue" || d === "Sentinelle" || d === "Patrouilleur" || d === "CombatantI" || d === "CombatantII" || d === "CombatantIII" || d === "Commando") {
            document.querySelector(".fuckingModal").style.display = "flex"
        }

        switch (d) {
            case "Postulant":
                focusTitle.innerText = "Postulant";
                focusImage.src = "images/OrgIcon/logoFCUBlanc.png"
                focusSubTitle.innerText = "Filtre à têtes de lard."
                focusDescription.innerText = "Le rang Postulant est une étape de rencontre. Venez rencontrer les copains sur Discord, participez à quelques soirées et vous serez automatiquement promu au rang de Recrue."
                focusDescription2.innerText = ""
                focusSolde.innerText = "- Formation: ~ 5 000 aUEC / heure"
                focusButin.innerText = "- Part du butin: 50%"
                focusPP.innerText = "- 1PP par activité"
                focusPrérequis.innerText = "- Aucun"
                focusPrérequis2.innerText = ""
                break;

            case "Recrue":
                focusTitle.innerText = "Recrue";
                focusImage.src = "images/OrgIcon/logoFCUBlanc.png"
                focusSubTitle.innerText = "Les choses sérieuses commencent."
                focusDescription.innerText = "Le rang Recrue permet de découvrir les mécaniques de base du jeu."
                focusDescription2.innerText = "Débloquer le rang Sentinelle et décrochez le tag =FCU= sur Discord."
                focusSolde.innerText = "- Formation: ~ 5 000 aUEC / heure"
                focusButin.innerText = "- Part du butin: 50%"
                focusPP.innerText = "- 1PP par activité"
                focusPrérequis.innerText = "- Être Postulant"
                focusPrérequis2.innerText = ""
                break;

            case "Sentinelle":
                focusTitle.innerText = "Sentinelle ";
                focusImage.src = "images/OrgIcon/logoFCUBlanc.png"
                focusSubTitle.innerText = 'Avec vous, les portes sont bien gardées !'
                focusDescription.innerHTML = `Le rang Sentinelle montre que vous souhaitez vous investir dans l'organisation et continuer votre progression. Vous débloquez le tag =FCU= sur Discord.`
                focusDescription2.innerHTML = `Débloquer le rang Patrouilleur et accèdez à de meilleurs avantages.`
                focusSolde.innerText = "- Formation: ~ 10 000 aUEC / heure"
                focusButin.innerText = "- Part du butin: 100%"
                focusPP.innerText = "- 2PP par activité"
                focusPrérequis.innerText = "- Être Recrue"
                focusPrérequis2.innerText = "- Avoir passé les certifications de bronze"
                break;

            case "Patrouilleur":
                focusTitle.innerText = "Patrouilleur";
                focusImage.src = "images/OrgIcon/logoFCUBlanc.png"
                focusSubTitle.innerText = "Le verse n'a pas de secret pour vous."
                focusDescription.innerHTML = `Le rang Patrouilleur signifie que vous êtes autonome et fiable,c'est un bon début. Ne relâchez pas vos efforts! `
                focusDescription2.innerHTML = `Vous pouvez accéder à la professionnalisation ou à une spécialisation.`
                focusSolde.innerText = "- Formation: ~ 10 000 aUEC / heure"
                focusButin.innerText = "- Part du butin: 125%"
                focusPP.innerText = "- 2PP par activité"
                focusPrérequis.innerText = "- Être Sentinelle"
                focusPrérequis2.innerText = "- Avoir passé les certifications d'argent"
                break;

            case "CombatantI":
                focusTitle.innerText = "Combatant I";
                focusImage.src = "images/OrgIcon/logoFCUBlanc.png"
                focusSubTitle.innerText = 'Le champ de bataille est votre maison.'
                focusDescription.innerHTML = `Le rang Combattant I ouvre la voie du soldat professionnel. Polyvalent et aguerri, il est un élément indispensable du champ de bataille.`
                focusDescription2.innerHTML = `Débloquer le rang Combattant II et accèdez à de meilleurs avantages.`
                focusSolde.innerText = "- Formation: ~ 10 000 aUEC / heure"
                focusButin.innerText = "- Part du butin: 150%"
                focusPP.innerText = "- 2PP par activité"
                focusPrérequis.innerText = "- Être Patrouilleur"
                focusPrérequis2.innerText = "- Avoir passé les certifications d'or"
                break;

            case "CombatantII":
                focusTitle.innerText = "Combatant II";
                focusImage.src = "images/OrgIcon/logoFCUBlanc.png"
                focusSubTitle.innerText = 'J\'aime l\'odeur du sang de bon matin.'
                focusDescription.innerHTML = `Le rang Combattant II confirme vos nombreux talents. Vous êtes taillé pour la guerre et nous avons de la chance de vous avoir.`
                focusDescription2.innerHTML = `Débloquer le rang Combattant III et accèdez à de meilleurs avantages.`
                focusSolde.innerText = "- Formation: ~ 15 000 aUEC / heure"
                focusButin.innerText = "- Part du butin: 165%"
                focusPP.innerText = "- 3PP par activité"
                focusPrérequis.innerText = "- Être Patrouilleur"
                focusPrérequis2.innerText = "- Avoir passé les certifications de platine"
                break;

            case "CombatantIII":
                focusTitle.innerText = "Combatant III";
                focusImage.src = "images/OrgIcon/logoFCUBlanc.png"
                focusSubTitle.innerText = 'Les massacres vous poussent peu à peu vers la folie.'
                focusDescription.innerHTML = `Le rang Combattant III vous place au rang des meilleurs soldats que porte la FCU. Vous inspirez les autres par vos prouesses et infligez la terreur dans les rangs adverses.`
                focusDescription2.innerHTML = `Débloquer le rang Commando et accèdez à de meilleurs avantages.`
                focusSolde.innerText = "- Formation: ~ 15 000 aUEC / heure"
                focusButin.innerText = "- Part du butin: 180%"
                focusPP.innerText = "- 3PP par activité"
                focusPrérequis.innerText = "- Être Patrouilleur"
                focusPrérequis2.innerText = "- Avoir passé les certifications de diamant"
                break;

            case "Commando":
                focusTitle.innerText = "Commando";
                focusImage.src = "images/OrgIcon/logoFCUBlanc.png"
                focusSubTitle.innerText = 'La guerre vous a rendu fou... ou peut-être l\'avez vous toujours été.'
                focusDescription.innerHTML = `Le rang Commando vous élève au rang de légende de votre art. Les mots n'ont plus de sens devant tant de perfection.`
                focusDescription2.innerHTML = ``
                focusSolde.innerText = "- Formation: ~ 20 000 aUEC / heure"
                focusButin.innerText = "- Part du butin: 200%"
                focusPP.innerText = "- 3PP par activité"
                focusPrérequis.innerText = "- Être Patrouilleur"
                focusPrérequis2.innerText = "- Avoir passé les certifications légendaires"
                break;

            default:
                break;
        }
    }

    function closeModal() {         // fermeture de la modal
        document.querySelector(".fuckingModal").style.display = "none"
    }

    useEffect(() => {
        setData(
            [

                //---------------------------------------------------------------Tronc commun------------------------------------------------//

                {
                    "name": "Postulant",
                    "imageUrl": "images/OrgIcon/logoFCUBlanc.png",
                    "id": "Postulant",
                },
                {
                    "name": "Recrue",
                    "imageUrl": "images/OrgIcon/logoFCUBlanc.png",
                    "id": "Recrue",
                    "parentId": "Postulant",
                },
                {
                    "name": "Sentinelle",
                    "imageUrl": "images/OrgIcon/logoFCUBlanc.png",
                    "id": "Sentinelle",
                    "parentId": "Recrue",

                },
                {
                    "name": "Patrouilleur",
                    "imageUrl": "images/OrgIcon/logoFCUBlanc.png",
                    "id": "Patrouilleur",
                    "parentId": "Sentinelle",

                },
                //---------------------------------------------------------------Transitions------------------------------------------------//

                {
                    "name": "Professionnalisation",
                    "imageUrl": "images/OrgIcon/NEW-VAA2-min.png",
                    "id": "Professionnalisation",
                    "parentId": "Patrouilleur",
                },
                {
                    "name": "Spécialisations",
                    "imageUrl": "images/OrgIcon/NEW-VAA2-min.png",
                    "id": "Spécialisations",
                    "parentId": "Patrouilleur",
                },

                {
                    "name": "Marines",
                    "imageUrl": "images/vitrine/logo/logoMarines.png",
                    "id": "Marines",
                    "parentId": "Spécialisations",
                },

                {
                    "name": "Flotte",
                    "imageUrl": "images/vitrine/logo/logoMarines.png",
                    "id": "Flotte",
                    "parentId": "Spécialisations",
                },

                {
                    "name": "Logistique",
                    "imageUrl": "images/vitrine/logo/logoMarines.png",
                    "id": "Logistique",
                    "parentId": "Spécialisations",
                },


                //---------------------------------------------------------------Tronc commum------------------------------------------------//

                {
                    "name": "Combatant I",
                    "imageUrl": "images/OrgIcon/logoFCUBlanc.png",
                    "id": "CombatantI",
                    "parentId": "Professionnalisation",
                },
                {
                    "name": "Combatant II",
                    "imageUrl": "images/OrgIcon/logoFCUBlanc.png",
                    "id": "CombatantII",
                    "parentId": "CombatantI",
                },
                {
                    "name": "Combatant III",
                    "imageUrl": "images/OrgIcon/logoFCUBlanc.png",
                    "id": "CombatantIII",
                    "parentId": "CombatantII",
                },
                {
                    "name": "Commando",
                    "imageUrl": "images/OrgIcon/logoFCUBlanc.png",
                    "id": "Commando",
                    "parentId": "CombatantIII",
                },

                //---------------------------------------------------------------Spécialisation------------------------------------------------//

                {
                    "name": "Infanterie I",
                    "imageUrl": "images/vitrine/logo/logoMarines.png",
                    "id": "InfanterieI",
                    "parentId": "Marines",
                },
                {
                    "name": "Infanterie II",
                    "imageUrl": "images/vitrine/logo/logoMarines.png",
                    "id": "InfanterieII",
                    "parentId": "InfanterieI",
                },
                {
                    "name": "Infanterie III",
                    "imageUrl": "images/vitrine/logo/logoMarines.png",
                    "id": "InfanterieIII",
                    "parentId": "InfanterieII",
                },
                {
                    "name": " Expert Infanterie ",
                    "imageUrl": "images/vitrine/logo/logoMarines.png",
                    "id": "ExpertInfanterie",
                    "parentId": "InfanterieIII",
                },
                {
                    "name": "Pilote GCE I",
                    "imageUrl": "images/vitrine/logo/logoFlotte.png",
                    "id": "PiloteGCEI",
                    "parentId": "Flotte",
                },
                {
                    "name": "Pilote GCE II",
                    "imageUrl": "images/vitrine/logo/logoFlotte.png",
                    "id": "PiloteGCEII",
                    "parentId": "PiloteGCEI",
                },
                {
                    "name": "Pilote GCE III",
                    "imageUrl": "images/vitrine/logo/logoFlotte.png",
                    "id": "PiloteGCEIII",
                    "parentId": "PiloteGCEII",
                },
                {
                    "name": "Expert Pilote GCE",
                    "imageUrl": "images/vitrine/logo/logoFlotte.png",
                    "id": "ExpertPiloteGCE",
                    "parentId": "PiloteGCEIII",
                },
                {
                    "name": "Pit Crew I",
                    "imageUrl": "images/vitrine/logo/logoLog.png",
                    "id": "PitCrewI",
                    "parentId": "Logistique",
                },
                {
                    "name": "Pit Crew II",
                    "imageUrl": "images/vitrine/logo/logoLog.png",
                    "id": "PitCrewII",
                    "parentId": "PitCrewI",
                },
                {
                    "name": "Pit Crew III",
                    "imageUrl": "images/vitrine/logo/logoLog.png",
                    "id": "PitCrewIII",
                    "parentId": "PitCrewII",
                },
                {
                    "name": "Expert Pit Crew",
                    "imageUrl": "images/vitrine/logo/logoLog.png",
                    "id": "ExpertPitCrew",
                    "parentId": "PitCrewIII",
                },
                {
                    "name": "Pilote GAE I",
                    "imageUrl": "images/vitrine/logo/logoFlotte.png",
                    "id": "PiloteGAEI",
                    "parentId": "Flotte",
                },
                {
                    "name": "Pilote GAE II",
                    "imageUrl": "images/vitrine/logo/logoFlotte.png",
                    "id": "PiloteGAEII",
                    "parentId": "PiloteGAEI",
                },
                {
                    "name": "Pilote GAE III",
                    "imageUrl": "images/vitrine/logo/logoFlotte.png",
                    "id": "PiloteGAEIII",
                    "parentId": "PiloteGAEII",
                },
                {
                    "name": "Expert Pilote GAE",
                    "imageUrl": "images/vitrine/logo/logoFlotte.png",
                    "id": "ExpertPiloteGAE",
                    "parentId": "PiloteGAEIII",
                },
            ]
        )
    }, []);


    return (
        <div className='progressionPage'>
            <Navbar />
            <div onClick={closeModal} className='fuckingModal'>
                <div className='fuckingModal__container'>
                    <img id='rankImage' src="" alt='rank logo' />

                    <span className='fuckingModal__container__text'>
                        <h1 id='rankTitle'>titre</h1>
                        <h3 id='rankSubTitle'>sous-titre</h3>
                        <span id='rankDescription'></span>
                        <span id='rankDescription2'></span>
                    </span>

                    <span className='fuckingModal__container__info'>
                        <div>
                            <h3>Avantages:</h3>
                            <p id='rankSolde'></p>
                            <p id='rankButin'></p>
                            <p id='rankPP'></p>
                        </div>
                        <div>
                            <h3>Prérequis:</h3>
                            <p id='rankPrerequis'></p>
                            <p id='rankPrerequis2'></p>
                        </div>
                    </span>

                </div>

            </div>
            <div className='progressionPage__container'>
                <OrgChartComponent
                    setClick={(click) => (addNodeChildFunc = click)}
                    onNodeClick={onNodeClick}
                    data={data}
                />

            </div>
        </div>

    );
};

export default ProgressionPage;